export const PhotoCaptureResourceLookupConstants = {
    USER_TYPE: 'BS',
    SEARCH_BY: 'radius',
    RADIUS: 25,
    SORT_FIELD: 'distance',
    REPAIR_SPEECHBOX_TEXT: 'Here are some repair facilities we have found near you.',
    ASSIGNMENT_TEXT: 'Assignment'
};
//# sourceMappingURL=PhotoCaptureResourceLookupConstants.js.map